module.exports = __webpack_public_path__ + "img/icons-12-sort.432320c1.svg";